import { CexNamesEnum, NetworkNamesEnum } from '@shared/enums/networks.enum';
import { CoingeckoCexes, CoingeckoNetworks } from '@shared/constants/coingecko-info';
import { CoingeckoDexNamesEnum, DexNamesEnum } from '@shared/enums/dex-names.enum';
import { RangeTypeEnum } from '@shared/enums/range.enum';
import { PermissionsEnum } from '@shared/enums/permissions.enum';

export class DexFull {
    constructor(
        public readonly dex: DexNamesEnum,
        public readonly coingeckoDex: CoingeckoDexNamesEnum,
        public readonly dexName: string,
        public readonly useNative: boolean,
        public readonly isFee: boolean,
        public readonly isEVM: boolean,
        public readonly nativeAddress: string,
        public readonly isMetamask: boolean,
        public readonly isPoolId: boolean,
        public readonly onlyNative?: boolean,
        public readonly availableStrats?: RangeTypeEnum[],
        public readonly isDisabled?: boolean,
        public readonly permission?: PermissionsEnum,
    ) {
    }
}
export class Network {
    constructor(
        public readonly name: string,
        public readonly fullName: string,
        public readonly networkAlias: string,
        public readonly iconName: string,
        public readonly network: NetworkNamesEnum | CexNamesEnum,
        public readonly isCex: boolean,
        public readonly coingeckoName: CoingeckoNetworks | CoingeckoCexes,
        public readonly blockExplorer?: string,
        public readonly dexscreener?: string,
        public readonly isMakers?: boolean,
        public readonly isHolders?: boolean,
        public readonly availableOnContract?: boolean,
        public readonly chainId?: number,
        public readonly isDisabled?: boolean,
        public readonly isPrivate?: boolean,
        public readonly dexes?: DexFull[],
        public readonly executionMethod?: 'batch' | 'single',
        public readonly maxBatchOrders?: number,
        public readonly isFarmAvailable?: boolean,
        public readonly tradingViewName?: string,
        public readonly permission?: PermissionsEnum,
        public readonly ob_lvls?: number,
    ) {
    }
}

export const DEX_NETWORKS: Network[] = [
        {
            name: "Ethereum",
            fullName: "Ethereum (ETH)",
            networkAlias: "ETH",
            iconName: "eth",
            network: NetworkNamesEnum.eth,
            isCex: false,
            coingeckoName: CoingeckoNetworks.Ethereum,
            blockExplorer: "https://etherscan.io/",
            dexscreener: "ethereum",
            isMakers: true,
            isHolders: true,
            availableOnContract: true,
            chainId: 1,
            isDisabled: false,
            isPrivate: true,
            dexes: [
                {
                    dex: DexNamesEnum.uniswap,
                    coingeckoDex: CoingeckoDexNamesEnum.uniswap,
                    dexName: "Uni",
                    useNative: true,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.sushiswap_eth,
                    coingeckoDex: CoingeckoDexNamesEnum.sushiswap_eth,
                    dexName: "Sushi",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.uniswap_v3,
                    coingeckoDex: CoingeckoDexNamesEnum.uniswap_v3,
                    dexName: "UniV3",
                    useNative: true,
                    isFee: true,
                    isEVM: true,
                    nativeAddress: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.shibaswap,
                    coingeckoDex: CoingeckoDexNamesEnum.shibaswap,
                    dexName: "Shibaswap",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false,
                    isDisabled: true,
                },
                {
                    dex: DexNamesEnum.balancer_eth,
                    coingeckoDex: CoingeckoDexNamesEnum.balancer_eth,
                    dexName: "Balancer",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: true,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.curve_eth,
                    coingeckoDex: CoingeckoDexNamesEnum.curve_eth,
                    dexName: "Curve",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: true,
                    onlyNative: false,
                    isDisabled: true,
                },
                {
                    dex: DexNamesEnum.uniswap_v4,
                    coingeckoDex:CoingeckoDexNamesEnum.uniswap_v4,
                    dexName: "UniV4",
                    useNative: true,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
                    isMetamask: true,
                    isPoolId: true,
                    onlyNative: true,
                    isDisabled: false,
                    availableStrats: [
                        RangeTypeEnum.buyback,
                        RangeTypeEnum.priceFollowing,
                        RangeTypeEnum.priceRetention,
                        RangeTypeEnum.sellback,
                        RangeTypeEnum.tradeVolume,
                    ],
                },
            ]
        },
        {
            name: "Avalanche",
            fullName: "Avalanche (Avax)",
            networkAlias: "AVAX",
            iconName: "ava",
            network: NetworkNamesEnum.ava,
            isCex: false,
            coingeckoName: CoingeckoNetworks.Avalanche,
            blockExplorer: "https://snowtrace.io/",
            dexscreener: "avalanche",
            isMakers: false,
            isHolders: false,
            availableOnContract: true,
            chainId: 43114,
            isDisabled: false,
            dexes: [
                {
                    dex: DexNamesEnum.pangolinswap,
                    coingeckoDex: CoingeckoDexNamesEnum.pangolinswap,
                    dexName: "Pangolin",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.joeswap,
                    coingeckoDex: CoingeckoDexNamesEnum.joeswap,
                    dexName: "Joe",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.joeswap_v2_ava,
                    coingeckoDex: CoingeckoDexNamesEnum.joeswap_v2_ava,
                    dexName: "Trader Joe V2",
                    useNative: false,
                    isFee: true,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                }
            ]
        },
        {
            name: "BSC Chain",
            fullName: "Binance Smart Chain (BNB)",
            networkAlias: "BNB",
            iconName: "bsc",
            network: NetworkNamesEnum.bsc,
            isCex: false,
            coingeckoName: CoingeckoNetworks.BSC,
            blockExplorer: "https://bscscan.com/",
            dexscreener: "bsc",
            isMakers: true,
            isHolders: true,
            availableOnContract: true,
            chainId: 56,
            isDisabled: false,
            isPrivate: true,
            dexes: [
                {
                    dex: DexNamesEnum.pancakeswap,
                    coingeckoDex: CoingeckoDexNamesEnum.pancakeswap,
                    dexName: "Pancake V2",
                    useNative: true,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.apeswap,
                    coingeckoDex: CoingeckoDexNamesEnum.apeswap,
                    dexName: "Ape",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.dmmswap,
                    coingeckoDex: null,
                    dexName: "Kyber/DMM",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false,
                    isDisabled: true,
                },
                {
                    dex: DexNamesEnum.sushiswap_bsc,
                    coingeckoDex: CoingeckoDexNamesEnum.sushiswap_bsc,
                    dexName: "Sushi",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.biswap,
                    coingeckoDex: CoingeckoDexNamesEnum.biswap,
                    dexName: "Biswap",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.knightswap,
                    coingeckoDex: CoingeckoDexNamesEnum.knightswap,
                    dexName: "Knightswap",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false,
                    isDisabled: true,
                },
                {
                    dex: DexNamesEnum.pancakeswap_v3,
                    coingeckoDex: CoingeckoDexNamesEnum.pancakeswap_v3,
                    dexName: "Pancake V3",
                    useNative: true,
                    isFee: true,
                    isEVM: true,
                    nativeAddress: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.uniswap_v3_bsc,
                    coingeckoDex: CoingeckoDexNamesEnum.uniswap_v3_bsc,
                    dexName: "UniV3",
                    useNative: true,
                    isFee: true,
                    isEVM: true,
                    nativeAddress: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.flapsh_bsc,
                    coingeckoDex: null,
                    dexName: "Flap.Sh",
                    useNative: true,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
                    isMetamask: false,
                    isPoolId: false,
                    onlyNative: true,
                    availableStrats: [RangeTypeEnum.buyback, RangeTypeEnum.sellback],
                    permission: PermissionsEnum.flapsh,
                    isDisabled: true,
                },
                {
                    dex: DexNamesEnum.fourmeme_bsc,
                    coingeckoDex: null,
                    dexName: "FourMeme",
                    useNative: true,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
                    isMetamask: false,
                    isPoolId: false,
                    onlyNative: true,
                    availableStrats: [RangeTypeEnum.buyback, RangeTypeEnum.sellback],
                    permission: PermissionsEnum.fourMeme,
                    isDisabled: false,
                },
            ]
        },
        {
            name: "Polygon",
            fullName: "Polygon (POL)",
            networkAlias: "POL",
            iconName: "pol",
            network: NetworkNamesEnum.pol,
            isCex: false,
            coingeckoName: CoingeckoNetworks.Polygon,
            blockExplorer: "https://polygonscan.com/",
            dexscreener: "polygon",
            isMakers: false,
            isHolders: false,
            availableOnContract: true,
            chainId: 137,
            isDisabled: false,
            dexes: [
                {
                    dex: DexNamesEnum.quickswap,
                    coingeckoDex: CoingeckoDexNamesEnum.quickswap,
                    dexName: "QuickSwap",
                    useNative: true,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.sushiswap_pol,
                    coingeckoDex: CoingeckoDexNamesEnum.sushiswap_pol,
                    dexName: "Sushi",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.uniswap_v3_pol,
                    coingeckoDex: CoingeckoDexNamesEnum.uniswap_v3_pol,
                    dexName: "UniV3",
                    useNative: true,
                    isFee: true,
                    isEVM: true,
                    nativeAddress: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.quickswap_v3,
                    coingeckoDex: CoingeckoDexNamesEnum.quickswap_v3,
                    dexName: "QuickSwap v3",
                    useNative: true,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.balancer_pol,
                    coingeckoDex: CoingeckoDexNamesEnum.balancer_pol,
                    dexName: "Balancer",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: true,
                    onlyNative: false,
                    isDisabled: false,
                },
                {
                    dex: DexNamesEnum.curve_pol,
                    coingeckoDex: CoingeckoDexNamesEnum.curve_pol,
                    dexName: "Curve",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: true,
                    onlyNative: false,
                    isDisabled: true,
                },
                {
                    dex: DexNamesEnum.uniswap_v4_pol,
                    coingeckoDex:CoingeckoDexNamesEnum.uniswap_v4_pol,
                    dexName: "UniV4",
                    useNative: true,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
                    isMetamask: true,
                    isPoolId: true,
                    onlyNative: true,
                    isDisabled: false,
                    availableStrats: [
                        RangeTypeEnum.buyback,
                        RangeTypeEnum.priceFollowing,
                        RangeTypeEnum.priceRetention,
                        RangeTypeEnum.sellback,
                        RangeTypeEnum.tradeVolume,
                    ],
                },
            ]
        },
        {
            name: "HECO",
            fullName: "HECO (HT)",
            networkAlias: "HT",
            iconName: "heco",
            network: NetworkNamesEnum.heco,
            isCex: false,
            coingeckoName: CoingeckoNetworks.HECO,
            blockExplorer: "https://hecoinfo.com/",
            dexscreener: "heco",
            isMakers: false,
            isHolders: false,
            availableOnContract: true,
            chainId: 128,
            isDisabled: true,
            dexes: [
                {
                    dex: DexNamesEnum.sushiswap_heco,
                    coingeckoDex: null,
                    dexName: "Sushi",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.mdexswap,
                    coingeckoDex: CoingeckoDexNamesEnum.mdexswap,
                    dexName: "MDEX",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                }
            ]
        },
        {
            name: "Optimism",
            fullName: "Optimism (ETH)",
            networkAlias: "ETH",
            iconName: "optimism",
            network: NetworkNamesEnum.optimism,
            isCex: false,
            coingeckoName: CoingeckoNetworks.Optimism,
            blockExplorer: "https://optimistic.etherscan.io/",
            dexscreener: "optimism",
            isMakers: false,
            isHolders: false,
            availableOnContract: true,
            chainId: 10,
            isDisabled: true,
            dexes: [
                {
                    dex: DexNamesEnum.uniswap_v3_opt,
                    coingeckoDex: CoingeckoDexNamesEnum.uniswap_v3_opt,
                    dexName: "UniV3",
                    useNative: false,
                    isFee: true,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                }
            ]
        },
        {
            name: "Arbitrum",
            fullName: "Arbitrum (ETH)",
            networkAlias: "ETH",
            iconName: "arbitrum",
            network: NetworkNamesEnum.arbitrum,
            isCex: false,
            coingeckoName: CoingeckoNetworks.Arbitrum,
            blockExplorer: "https://arbiscan.io/",
            dexscreener: "arbitrum",
            isMakers: false,
            isHolders: false,
            availableOnContract: true,
            chainId: 42161,
            isDisabled: false,
            dexes: [
                {
                    dex: DexNamesEnum.uniswap_v3_arb,
                    coingeckoDex: CoingeckoDexNamesEnum.uniswap_v3_arb,
                    dexName: "UniV3",
                    useNative: true,
                    isFee: true,
                    isEVM: true,
                    nativeAddress: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.oreoswap,
                    coingeckoDex: CoingeckoDexNamesEnum.oreoswap,
                    dexName: "OreoSwap",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false,
                    isDisabled: true,
                },
                {
                    dex: DexNamesEnum.zyberswap,
                    coingeckoDex: CoingeckoDexNamesEnum.zyberswap,
                    dexName: "Zyberswap",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false,
                    isDisabled: true,
                },
                {
                    dex: DexNamesEnum.alienswap,
                    coingeckoDex: null,
                    dexName: "Alienswap",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false,
                    isDisabled: true,
                },
                {
                    dex: DexNamesEnum.camelot,
                    coingeckoDex: CoingeckoDexNamesEnum.camelot,
                    dexName: "Camelot",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.zyberswap_v3,
                    coingeckoDex: CoingeckoDexNamesEnum.zyberswap,
                    dexName: "Zyberswap V3",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false,
                    isDisabled: true,
                },
                {
                    dex: DexNamesEnum.dexSwap,
                    coingeckoDex: null,
                    dexName: "dexSWAP",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false,
                    isDisabled: true,
                },
                {
                    dex: DexNamesEnum.joeswap_v2_arb,
                    coingeckoDex: CoingeckoDexNamesEnum.joeswap_v2_arb,
                    dexName: "Trader Joe V2",
                    useNative: false,
                    isFee: true,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.camelot_v3,
                    coingeckoDex: CoingeckoDexNamesEnum.camelot_v3,
                    dexName: "Camelot V3",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.sushiswap_arb,
                    coingeckoDex: CoingeckoDexNamesEnum.sushiswap_arb,
                    dexName: "Sushi",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.sushiswap_v3_arb,
                    coingeckoDex: CoingeckoDexNamesEnum.sushiswap_v3_arb,
                    dexName: "Sushi V3",
                    useNative: false,
                    isFee: true,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.balancer_arb,
                    coingeckoDex: CoingeckoDexNamesEnum.balancer_arb,
                    dexName: "Balancer",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: true,
                    onlyNative: false,
                    isDisabled: true,
                },
                {
                    dex: DexNamesEnum.pancakeswap_arb,
                    coingeckoDex: CoingeckoDexNamesEnum.pancakeswap_arb,
                    dexName: "Pancake V2",
                    useNative: true,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false,
                },
            ]
        },
        {
            name: "ZKSync Era",
            fullName: "ZKSync Era (ETH)",
            networkAlias: "ETH",
            iconName: "zksync-era",
            network: NetworkNamesEnum.zksync,
            isCex: false,
            coingeckoName: CoingeckoNetworks.ZkSync,
            blockExplorer: "https://explorer.zksync.io/",
            dexscreener: "zksync",
            isMakers: false,
            isHolders: false,
            availableOnContract: true,
            chainId: 324,
            isDisabled: true,
            dexes: [
                {
                    dex: DexNamesEnum.pancakeswap_zksync,
                    coingeckoDex: CoingeckoDexNamesEnum.pancakeswap_zksync,
                    dexName: "Pancake V2",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.pancakeswap_v3_zksync,
                    coingeckoDex: CoingeckoDexNamesEnum.pancakeswap_v3_zksync,
                    dexName: "Pancake V3",
                    useNative: false,
                    isFee: true,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                }
            ]
        },
        {
            name: "Base",
            fullName: "Base (ETH)",
            networkAlias: "ETH",
            iconName: "base",
            network: NetworkNamesEnum.base,
            isCex: false,
            coingeckoName: CoingeckoNetworks.Base,
            blockExplorer: "https://basescan.org/",
            dexscreener: "base",
            isMakers: false,
            isHolders: false,
            availableOnContract: true,
            chainId: 8453,
            isDisabled: false,
            dexes: [
                {
                    dex: DexNamesEnum.uniswap_v3_base,
                    coingeckoDex: CoingeckoDexNamesEnum.uniswap_v3_base,
                    dexName: "UniV3",
                    useNative: true,
                    isFee: true,
                    isEVM: true,
                    nativeAddress: "0x4200000000000000000000000000000000000006",
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.synthswap,
                    coingeckoDex: CoingeckoDexNamesEnum.synthswap,
                    dexName: "Synthswap",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false,
                    isDisabled: true,
                },
                {
                    dex: DexNamesEnum.synthswap_v3,
                    coingeckoDex: CoingeckoDexNamesEnum.synthswap_v3,
                    dexName: "Synthswap V3",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false,
                    isDisabled: true,
                },
                {
                    dex: DexNamesEnum.sushiswap_base,
                    coingeckoDex: CoingeckoDexNamesEnum.sushiswap_base,
                    dexName: "Sushi",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.uniswap_base,
                    coingeckoDex: CoingeckoDexNamesEnum.uniswap_base,
                    dexName: "Uni",
                    useNative: true,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: "0x4200000000000000000000000000000000000006",
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.alien_base,
                    coingeckoDex: CoingeckoDexNamesEnum.alien_base,
                    dexName: "Alien",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.alien_v3_base,
                    coingeckoDex: CoingeckoDexNamesEnum.alien_v3_base,
                    dexName: "Alien V3",
                    useNative: false,
                    isFee: true,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false,
                },
                {
                    dex: DexNamesEnum.aerodrome_base,
                    coingeckoDex: CoingeckoDexNamesEnum.aerodrome_base,
                    dexName: "Aerodrome",
                    useNative: true,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: "0x4200000000000000000000000000000000000006",
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.trebleswap,
                    coingeckoDex: null,
                    dexName: "TrebleSwap",
                    useNative: true,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: "0x4200000000000000000000000000000000000006",
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
            ]
        },
        {
            name: "Solana",
            fullName: "Solana (SOL)",
            networkAlias: "SOL",
            iconName: "solana",
            network: NetworkNamesEnum.solana,
            isCex: false,
            coingeckoName: CoingeckoNetworks.Solana,
            blockExplorer: "https://solscan.io/",
            dexscreener: "solana",
            isMakers: true,
            isHolders: true,
            availableOnContract: false,
            chainId: 0,
            isDisabled: false,
            isPrivate: true,
            isFarmAvailable: true,
            dexes: [
                {
                    dex: DexNamesEnum.raydium,
                    coingeckoDex: CoingeckoDexNamesEnum.raydium,
                    dexName: "Raydium",
                    useNative: true,
                    isFee: false,
                    isEVM: false,
                    nativeAddress: "So11111111111111111111111111111111111111112",
                    isMetamask: false,
                    isPoolId: true,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.raydium_v3,
                    coingeckoDex: null,
                    dexName: "Raydium V3",
                    useNative: true,
                    isFee: false,
                    isEVM: false,
                    nativeAddress: "So11111111111111111111111111111111111111112",
                    isMetamask: false,
                    isPoolId: true,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.meteora,
                    coingeckoDex: CoingeckoDexNamesEnum.meteora,
                    dexName: "Meteora",
                    useNative: true,
                    isFee: false,
                    isEVM: false,
                    nativeAddress: "So11111111111111111111111111111111111111112",
                    isMetamask: false,
                    isPoolId: true,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.meteora_dlmm,
                    coingeckoDex: null,
                    dexName: "Meteora DLMM",
                    useNative: true,
                    isFee: false,
                    isEVM: false,
                    nativeAddress: "So11111111111111111111111111111111111111112",
                    isMetamask: false,
                    isPoolId: true,
                    onlyNative: false,
                    availableStrats: [
                        RangeTypeEnum.buy,
                        RangeTypeEnum.buyback,
                        RangeTypeEnum.fairLaunch,
                        RangeTypeEnum.liquidity,
                        RangeTypeEnum.priceFollowing,
                        RangeTypeEnum.priceRetention,
                        RangeTypeEnum.sell,
                        RangeTypeEnum.sellback,
                        RangeTypeEnum.tradeVolume,
                        RangeTypeEnum.transferBundler,
                    ],
                },
                {
                    dex: DexNamesEnum.pumpfun,
                    coingeckoDex: null,
                    dexName: "PumpFun",
                    useNative: true,
                    isFee: false,
                    isEVM: false,
                    nativeAddress: "So11111111111111111111111111111111111111112",
                    isMetamask: false,
                    isPoolId: false,
                    onlyNative: true,
                    availableStrats: [RangeTypeEnum.buyback, RangeTypeEnum.sellback, RangeTypeEnum.transferBundler],
                    permission: PermissionsEnum.pumpFun,
                },
                {
                    dex: DexNamesEnum.pumpswap,
                    coingeckoDex: CoingeckoDexNamesEnum.pumpswap,
                    dexName: "PumpSwap",
                    useNative: true,
                    isFee: false,
                    isEVM: false,
                    nativeAddress: "So11111111111111111111111111111111111111112",
                    isMetamask: false,
                    isPoolId: true,
                    onlyNative: false,
                    availableStrats: [RangeTypeEnum.sellback, RangeTypeEnum.buyback, RangeTypeEnum.tradeVolume, RangeTypeEnum.buy, RangeTypeEnum.sell, RangeTypeEnum.transferBundler],
                },
                {
                    dex: DexNamesEnum.orca,
                    coingeckoDex: CoingeckoDexNamesEnum.orca,
                    dexName: "Orca",
                    useNative: true,
                    isFee: false,
                    isEVM: false,
                    nativeAddress: "So11111111111111111111111111111111111111112",
                    isMetamask: false,
                    isPoolId: true,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.cooldex,
                    coingeckoDex: null,
                    dexName: "CoolDex",
                    useNative: true,
                    isFee: false,
                    isEVM: false,
                    nativeAddress: "So11111111111111111111111111111111111111112",
                    isMetamask: false,
                    isPoolId: true,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.something_cool,
                    coingeckoDex: null,
                    dexName: "SomethingCool",
                    useNative: true,
                    isFee: false,
                    isEVM: false,
                    nativeAddress: "So11111111111111111111111111111111111111112",
                    isMetamask: false,
                    isPoolId: false,
                    onlyNative: true,
                    availableStrats: [RangeTypeEnum.buyback, RangeTypeEnum.sellback],
                    permission: PermissionsEnum.somethingCool,
                },
                {
                    dex: DexNamesEnum.raydium_launchlab,
                    coingeckoDex: null,
                    dexName: "Raydium LaunchLab",
                    useNative: true,
                    isFee: false,
                    isEVM: false,
                    nativeAddress: "So11111111111111111111111111111111111111112",
                    isMetamask: false,
                    isPoolId: false,
                    onlyNative: true,
                    availableStrats: [RangeTypeEnum.buyback, RangeTypeEnum.sellback],
                    permission: PermissionsEnum.raydiumLaunchLab,
                },
            ]
        },
        {
            name: "Blast",
            fullName: "Blast (ETH)",
            networkAlias: "ETH",
            iconName: "blast",
            network: NetworkNamesEnum.blast,
            isCex: false,
            coingeckoName: CoingeckoNetworks.Blast,
            blockExplorer: "https://blastscan.io/",
            dexscreener: "blast",
            isMakers: false,
            isHolders: false,
            availableOnContract: false,
            chainId: 81457,
            isDisabled: false,
            dexes: [
                {
                    dex: DexNamesEnum.thruster_v2,
                    coingeckoDex: CoingeckoDexNamesEnum.thruster_v2,
                    dexName: "Thruster V2",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.thruster_v3,
                    coingeckoDex: CoingeckoDexNamesEnum.thruster_v3,
                    dexName: "Thruster V3",
                    useNative: false,
                    isFee: true,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.cyberblast_v2,
                    coingeckoDex: CoingeckoDexNamesEnum.cyberblast_v2,
                    dexName: "Cyberblast V2",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false,
                    isDisabled: true,
                },
                {
                    dex: DexNamesEnum.cyberblast_v3,
                    coingeckoDex: CoingeckoDexNamesEnum.cyberblast_v3,
                    dexName: "Cyberblast V3",
                    useNative: false,
                    isFee: true,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false,
                    isDisabled: true,
                }
            ]
        },
        {
            name: "TON",
            fullName: "TON (TON)",
            networkAlias: "TON",
            iconName: "ton",
            network: NetworkNamesEnum.ton,
            isCex: false,
            coingeckoName: CoingeckoNetworks.Ton,
            blockExplorer: "https://tonscan.org/",
            dexscreener: "ton",
            isMakers: false,
            isHolders: false,
            availableOnContract: false,
            chainId: 100000000001,
            isDisabled: false,
            dexes: [
                {
                    dex: DexNamesEnum.dedust,
                    coingeckoDex: CoingeckoDexNamesEnum.dedust,
                    dexName: "DeDust",
                    useNative: false,
                    isFee: false,
                    isEVM: false,
                    nativeAddress: null,
                    isMetamask: false,
                    isPoolId: true,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.hypecoin,
                    coingeckoDex: null,
                    dexName: "Hypecoin",
                    useNative: false,
                    isFee: false,
                    isEVM: false,
                    nativeAddress: null,
                    isMetamask: false,
                    isPoolId: false,
                    onlyNative: false,
                    isDisabled: true,
                },
                {
                    dex: DexNamesEnum.stonfi,
                    coingeckoDex: CoingeckoDexNamesEnum.stonfi,
                    dexName: "StonFi",
                    useNative: false,
                    isFee: false,
                    isEVM: false,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: true,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.stonfi_v2,
                    coingeckoDex: CoingeckoDexNamesEnum.stonfi_v2,
                    dexName: "StonFi V2",
                    useNative: false,
                    isFee: false,
                    isEVM: false,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: true,
                    onlyNative: false
                }
            ]
        },
        {
            name: "HAQQ",
            fullName: "HAQQ (ISLM)",
            networkAlias: "ISLM",
            iconName: "haqq",
            network: NetworkNamesEnum.haqq,
            isCex: false,
            coingeckoName: null,
            blockExplorer: "https://explorer.haqq.network/",
            dexscreener: "haqq",
            isMakers: false,
            isHolders: false,
            availableOnContract: true,
            chainId: 11235,
            isDisabled: true,
            dexes: [
                {
                    dex: DexNamesEnum.sushiswap_haqq,
                    coingeckoDex: null,
                    dexName: "Sushi",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.sushiswap_v3_haqq,
                    coingeckoDex: null,
                    dexName: "Sushi V3",
                    useNative: false,
                    isFee: true,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                }
            ]
        },
        {
            name: "Vitruveo",
            fullName: "Vitruveo (VTRU)",
            networkAlias: "VTRU",
            iconName: "vtru",
            network: NetworkNamesEnum.vtru,
            isCex: false,
            coingeckoName: null,
            blockExplorer: "https://explorer.vitruveo.xyz/",
            dexscreener: "vtru",
            isMakers: false,
            isHolders: false,
            availableOnContract: false,
            chainId: 1490,
            isDisabled: true,
            dexes: [
                {
                    dex: DexNamesEnum.vtru,
                    coingeckoDex: null,
                    dexName: "VTRU",
                    useNative: false,
                    isFee: false,
                    isEVM: false,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                }
            ]
        },
        {
            name: "Saakuru",
            fullName: "Saakuru (OAS)",
            networkAlias: "OAS",
            iconName: "saakuru",
            network: NetworkNamesEnum.saakuru,
            isCex: false,
            coingeckoName: CoingeckoNetworks.Saakuru,
            blockExplorer: "https://explorer.saakuru.network/",
            dexscreener: "bsc",
            isMakers: false,
            isHolders: false,
            availableOnContract: false,
            chainId: 7225878,
            isDisabled: false,
            dexes: [
                {
                    dex: DexNamesEnum.taffy,
                    coingeckoDex: CoingeckoDexNamesEnum.taffy,
                    dexName: "Taffy",
                    useNative: false,
                    isFee: false,
                    isEVM: false,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                }
            ]
        },
        {
            name: "Tron",
            fullName: "Tron (TRX)",
            networkAlias: "TRX",
            iconName: "tron",
            network: NetworkNamesEnum.tron,
            isCex: false,
            coingeckoName: CoingeckoNetworks.Tron,
            blockExplorer: "https://tronscan.org/",
            dexscreener: "tron",
            isMakers: false,
            isHolders: false,
            availableOnContract: false,
            chainId: 1000,
            isDisabled: false,
            dexes: [
                {
                    dex: DexNamesEnum.sunswap,
                    coingeckoDex: CoingeckoDexNamesEnum.sunswap,
                    dexName: "SunSwap",
                    useNative: false,
                    isFee: false,
                    isEVM: false,
                    nativeAddress: null,
                    isMetamask: false,
                    isPoolId: false,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.sunpump,
                    coingeckoDex: CoingeckoDexNamesEnum.sunpump,
                    dexName: "SunPump",
                    useNative: true,
                    isFee: false,
                    isEVM: false,
                    nativeAddress: "TNUC9Qb1rRpS5CbWLmNMxXBjyFoydXjWFR",
                    isMetamask: false,
                    isPoolId: false,
                    onlyNative: true
                }
            ]
        },
        {
            name: "Mode",
            fullName: "Mode (ETH)",
            networkAlias: "ETH",
            iconName: "mode",
            network: NetworkNamesEnum.mode,
            isCex: false,
            coingeckoName: CoingeckoNetworks.Mode,
            blockExplorer: "https://modescan.io/",
            dexscreener: "mode",
            isMakers: false,
            isHolders: false,
            availableOnContract: true,
            chainId: 34443,
            isDisabled: true,
            dexes: [
                {
                    dex: DexNamesEnum.kim,
                    coingeckoDex: CoingeckoDexNamesEnum.kim,
                    dexName: "Kim",
                    useNative: false,
                    isFee: false,
                    isEVM: false,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                }
            ]
        },
        {
            name: "Mantle",
            fullName: "Mantle (MNT)",
            networkAlias: "MNT",
            iconName: "mantle",
            network: NetworkNamesEnum.mantle,
            isCex: false,
            coingeckoName: CoingeckoNetworks.Mantle,
            blockExplorer: "https://explorer.mantle.xyz/",
            dexscreener: "mantle",
            isMakers: false,
            isHolders: false,
            availableOnContract: true,
            chainId: 5000,
            isDisabled: true,
            dexes: [
                {
                    dex: DexNamesEnum.uniswap_v3_mantle,
                    coingeckoDex: null,
                    dexName: "UniV3",
                    useNative: false,
                    isFee: true,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                }
            ]
        },
        {
            name: "SUI",
            fullName: "Sui (SUI)",
            networkAlias: "SUI",
            iconName: "sui",
            network: NetworkNamesEnum.sui,
            isCex: false,
            coingeckoName: CoingeckoNetworks.Sui,
            blockExplorer: "https://suivision.xyz/",
            dexscreener: "sui",
            isMakers: false,
            isHolders: false,
            availableOnContract: false,
            chainId: 101,
            isDisabled: false,
            dexes: [
                {
                    dex: DexNamesEnum.cetus_sui,
                    coingeckoDex: CoingeckoDexNamesEnum.cetus_sui,
                    dexName: "Cetus",
                    useNative: true,
                    isFee: false,
                    isEVM: false,
                    nativeAddress: "0x2::sui::SUI",
                    isMetamask: false,
                    isPoolId: true,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.turbos_sui,
                    coingeckoDex: CoingeckoDexNamesEnum.turbos_sui,
                    dexName: "Turbos",
                    useNative: true,
                    isFee: false,
                    isEVM: false,
                    nativeAddress: "0x2::sui::SUI",
                    isMetamask: false,
                    isPoolId: true,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.bluefin_sui,
                    coingeckoDex: CoingeckoDexNamesEnum.bluefin_sui,
                    dexName: "Bluefin",
                    useNative: true,
                    isFee: false,
                    isEVM: false,
                    nativeAddress: "0x2::sui::SUI",
                    isMetamask: false,
                    isPoolId: true,
                    onlyNative: false,
                    permission: PermissionsEnum.bluefin,
                },
                {
                    dex: DexNamesEnum.momentum_sui,
                    coingeckoDex: null,
                    dexName: "Momentum",
                    useNative: true,
                    isFee: false,
                    isEVM: false,
                    nativeAddress: "0x2::sui::SUI",
                    isMetamask: false,
                    isPoolId: true,
                    onlyNative: false,
                    permission: PermissionsEnum.momentum,
                },
            ]
        },
        {
            name: "Kaia",
            fullName: "Kaia (KLAY)",
            networkAlias: "KLAY",
            iconName: "kaia",
            network: NetworkNamesEnum.kaia,
            isCex: false,
            coingeckoName: CoingeckoNetworks.Kaia,
            blockExplorer: "https://kaiascope.com/",
            isMakers: false,
            isHolders: false,
            availableOnContract: false,
            chainId: 8217,
            isDisabled: false,
            dexes: [
                {
                    dex: DexNamesEnum.kaiaswap,
                    coingeckoDex: CoingeckoDexNamesEnum.kaiaswap,
                    dexName: "KaiaSwap",
                    useNative: false,
                    isFee: true,
                    isEVM: false,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: true,
                    onlyNative: false
                },
                {
                    dex: DexNamesEnum.klayswap_v2,
                    coingeckoDex: CoingeckoDexNamesEnum.klayswap_v2,
                    dexName: "KlaySwap",
                    useNative: false,
                    isFee: false,
                    isEVM: false,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: true,
                    onlyNative: false
                }
            ]
        },
        {
            name: "Unit0",
            fullName: "Unit0 (UNIT0)",
            networkAlias: "UNIT0",
            iconName: "unitzero",
            network: NetworkNamesEnum.unitzero,
            isCex: false,
            coingeckoName: CoingeckoNetworks.Unit,
            blockExplorer: "https://explorer.unit0.dev/",
            isMakers: false,
            isHolders: false,
            availableOnContract: false,
            chainId: 88819,
            isDisabled: true,
            dexes: [
                {
                    dex: DexNamesEnum.unitsswop,
                    coingeckoDex: null,
                    dexName: "UnitsSwop",
                    useNative: true,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: "0xCF43F7703d9B4E8835f977eF364B4014fA7e856E",
                    isMetamask: false,
                    isPoolId: false,
                    onlyNative: false
                }
            ]
        },
        {
            name: "Kava",
            fullName: "Kava (KAVA)",
            networkAlias: "KAVA",
            iconName: "kava",
            network: NetworkNamesEnum.kava,
            isCex: false,
            coingeckoName: CoingeckoNetworks.Kava,
            blockExplorer: "https://kavascan.com/",
            dexscreener: "kava",
            isMakers: false,
            isHolders: false,
            availableOnContract: false,
            chainId: 2222,
            isDisabled: true,
            dexes: [
                {
                    dex: DexNamesEnum.wagmi,
                    coingeckoDex: CoingeckoDexNamesEnum.wagmi,
                    dexName: "WAGMI",
                    useNative: true,
                    isFee: true,
                    isEVM: true,
                    nativeAddress: "0xc86c7C0eFbd6A49B35E8714C5f59D99De09A225b",
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false
                }
            ]
        },
        {
            name: "XRP",
            fullName: "Ripple (XRP)",
            networkAlias: "XRP",
            iconName: "xrpl",
            network: NetworkNamesEnum.xrpl,
            isCex: false,
            coingeckoName: CoingeckoNetworks.Xrp,
            blockExplorer: "https://xrpscan.com/",
            dexscreener: "xrpl",
            isMakers: false,
            isHolders: false,
            availableOnContract: false,
            chainId: null,
            isDisabled: false,
            permission: PermissionsEnum.xrpl,
            dexes: [
                {
                    dex: DexNamesEnum.xrpl_dex,
                    coingeckoDex: null,
                    dexName: "XRP",
                    useNative: false,
                    isFee: false,
                    isEVM: false,
                    nativeAddress: "XRP",
                    isMetamask: false,
                    isPoolId: true,
                    onlyNative: false,
                }
            ]
        },
        {
            name: "Soneium",
            fullName: "Soneium (ETH)",
            networkAlias: "ETH",
            iconName: "soneium",
            network: NetworkNamesEnum.soneium,
            isCex: false,
            coingeckoName: null,
            blockExplorer: "https://soneium.blockscout.com/",
            dexscreener: "soneium",
            isMakers: false,
            isHolders: false,
            availableOnContract: false,
            chainId: 1868,
            isDisabled: false,
            isPrivate: false,
            dexes: [
                {
                    dex: DexNamesEnum.kyo_soneium,
                    coingeckoDex: CoingeckoDexNamesEnum.kyo_soneium,
                    dexName: "Kyo Finance v2",
                    useNative: true,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: '0x4200000000000000000000000000000000000006',
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false,
                },
                {
                    dex: DexNamesEnum.kyo_v3_soneium,
                    coingeckoDex: CoingeckoDexNamesEnum.kyo_v3_soneium,
                    dexName: "Kyo Finance v3",
                    useNative: true,
                    isFee: true,
                    isEVM: true,
                    nativeAddress: '0x4200000000000000000000000000000000000006',
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false,
                },
                {
                    dex: DexNamesEnum.velodrome_soneium,
                    coingeckoDex: CoingeckoDexNamesEnum.velodrome_soneium,
                    dexName: "Velodrome Finance",
                    useNative: true,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: '0x4200000000000000000000000000000000000006',
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false,
                },
                {
                    dex: DexNamesEnum.velodrome_v2_soneium,
                    coingeckoDex: CoingeckoDexNamesEnum.velodrome_soneium,
                    dexName: "Velodrome Finance v2",
                    useNative: true,
                    isFee: true,
                    isEVM: true,
                    nativeAddress: '0x4200000000000000000000000000000000000006',
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false,
                },
            ]
        },
        {
            name: "Berachain",
            fullName: "Berachain (BERA)",
            networkAlias: "BERA",
            iconName: "berachain",
            network: NetworkNamesEnum.berachain,
            isCex: false,
            coingeckoName: CoingeckoNetworks.Berachain,
            blockExplorer: "https://berascan.com/",
            dexscreener: "berachain",
            isMakers: false,
            isHolders: false,
            availableOnContract: false,
            chainId: 80094,
            isDisabled: false,
            isPrivate: false,
            dexes: [
                {
                    dex: DexNamesEnum.beraswap,
                    coingeckoDex: null,
                    dexName: "Beraswap",
                    useNative: false,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: null,
                    isMetamask: true,
                    isPoolId: true,
                    onlyNative: false
                },
            ],
        },
        {
            name: "Sonic",
            fullName: "Sonic (S)",
            networkAlias: "S",
            iconName: "sonic",
            network: NetworkNamesEnum.sonic,
            isCex: false,
            coingeckoName: CoingeckoNetworks.Sonic,
            blockExplorer: "https://sonicscan.org/",
            dexscreener: "sonic",
            isMakers: false,
            isHolders: false,
            availableOnContract: false,
            chainId: 146,
            isDisabled: false,
            isPrivate: false,
            dexes: [
                {
                    dex: DexNamesEnum.sonic_shadow_dex,
                    coingeckoDex: CoingeckoDexNamesEnum.sonic_shadow_dex,
                    dexName: "Shadow",
                    useNative: true,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: '0x039e2fB66102314Ce7b64Ce5Ce3E5183bc94aD38',
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false,
                },
                {
                    dex: DexNamesEnum.sonic_v3_shadow_dex,
                    coingeckoDex: CoingeckoDexNamesEnum.sonic_v3_shadow_dex,
                    dexName: "Shadow v3",
                    useNative: true,
                    isFee: true,
                    isEVM: true,
                    nativeAddress: '0x039e2fB66102314Ce7b64Ce5Ce3E5183bc94aD38',
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false,
                },
            ],
        },
        // {
        //     name: "Solana DEV",
        //     fullName: "Solana DEV (SOL)",
        //     networkAlias: "SOL",
        //     iconName: "solana",
        //     network: NetworkNamesEnum.solana_dev,
        //     isCex: false,
        //     coingeckoName: null,
        //     blockExplorer: "https://solscan.io/",
        //     dexscreener: "solana",
        //     isMakers: true,
        //     isHolders: true,
        //     availableOnContract: false,
        //     chainId: 0,
        //     isDisabled: false,
        //     isPrivate: true,
        //     isFarmAvailable: true,
        //     dexes: [
        //         {
        //             dex: DexNamesEnum.raydium_v2_dev,
        //             coingeckoDex: CoingeckoDexNamesEnum.raydium,
        //             dexName: "Raydium v2 DEV",
        //             useNative: true,
        //             isFee: false,
        //             isEVM: false,
        //             nativeAddress: "So11111111111111111111111111111111111111112",
        //             isMetamask: false,
        //             isPoolId: true,
        //             onlyNative: false
        //         },
        //     ]
        // },
        {
            name: "HyperEvm",
            fullName: "HyperEvm (HYPE)",
            networkAlias: "HYPE",
            iconName: "hyperevm",
            network: NetworkNamesEnum.hyperEVM,
            isCex: false,
            coingeckoName: CoingeckoNetworks.Hyperevm,
            blockExplorer: "https://www.hyperscan.com/",
            dexscreener: "hyperevm",
            isMakers: false,
            isHolders: false,
            availableOnContract: false,
            chainId: 999,
            isDisabled: false,
            isPrivate: false,
            permission: PermissionsEnum.hyperevm,
            dexes: [
                {
                    dex: DexNamesEnum.hyperswap_v2,
                    coingeckoDex: CoingeckoDexNamesEnum.hyperswap_v2,
                    dexName: "Hyperswap V2",
                    useNative: true,
                    isFee: false,
                    isEVM: true,
                    nativeAddress: '0x5555555555555555555555555555555555555555',
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false,
                },
                {
                    dex: DexNamesEnum.hyperswap_v3,
                    coingeckoDex: CoingeckoDexNamesEnum.hyperswap_v3,
                    dexName: "Hyperswap V3",
                    useNative: true,
                    isFee: true,
                    isEVM: true,
                    nativeAddress: "0x5555555555555555555555555555555555555555",
                    isMetamask: true,
                    isPoolId: false,
                    onlyNative: false,
                },
            ],
        }
];

export const CEX_NETWORKS: Network[] = [
    {
        name: "Gate.io",
        fullName: "Gate.io",
        networkAlias: "gate",
        iconName: "gateio",
        network: CexNamesEnum.gateio,
        isCex: true,
        coingeckoName: CoingeckoCexes.gateio,
        executionMethod: 'batch',
        maxBatchOrders: 10,
        tradingViewName: 'GATEIO',
        ob_lvls: 500,
    },
    {
        name: "Binance",
        fullName: "Binance",
        networkAlias: "binance",
        iconName: "binance",
        network: CexNamesEnum.binance,
        isCex: true,
        coingeckoName: CoingeckoCexes.binance,
        executionMethod: 'single',
        maxBatchOrders: 0,
        tradingViewName: 'BINANCE',
        ob_lvls: 100,
    },
    {
        name: "MEXC Global",
        fullName: "MEXC Global",
        networkAlias: "mxc",
        iconName: "mexc",
        network: CexNamesEnum.mexc,
        isCex: true,
        coingeckoName: CoingeckoCexes.mexc,
        executionMethod: 'batch',
        maxBatchOrders: 20,
        tradingViewName: 'MEXC',
        ob_lvls: 500,
    },
    {
        name: "HTX",
        fullName: "HTX",
        networkAlias: "huobipro",
        iconName: "huobipro",
        network: CexNamesEnum.huobipro,
        isCex: true,
        coingeckoName: CoingeckoCexes.huobipro,
        executionMethod: 'single',
        maxBatchOrders: 0,
        tradingViewName: 'HTX',
        ob_lvls: 150,
    },
    {
        name: "KuCoin",
        fullName: "KuCoin",
        networkAlias: "kucoin",
        iconName: "kucoin",
        network: CexNamesEnum.kucoin,
        isCex: true,
        coingeckoName: CoingeckoCexes.kucoin,
        executionMethod: 'batch',
        maxBatchOrders: 5,
        tradingViewName: 'KUCOIN',
        ob_lvls: 100,
    },
    {
        name: "Whitebit",
        fullName: "Whitebit",
        networkAlias: "whitebit",
        iconName: "whitebit",
        network: CexNamesEnum.whitebit,
        isCex: true,
        coingeckoName: CoingeckoCexes.whitebit,
        executionMethod: 'single',
        maxBatchOrders: 0,
        tradingViewName: 'WHITEBIT',
        ob_lvls: 500,
    },
    {
        name: "OKX",
        fullName: "OKX",
        networkAlias: "okx",
        iconName: "okx",
        network: CexNamesEnum.okx,
        isCex: true,
        coingeckoName: CoingeckoCexes.okx,
        executionMethod: 'single',
        maxBatchOrders: 0,
        tradingViewName: 'OKX',
        ob_lvls: 100,
    },
    {
        name: "BitMart",
        fullName: "BitMart",
        networkAlias: "bitmart",
        iconName: "bitmart",
        network: CexNamesEnum.bitmart,
        isCex: true,
        coingeckoName: null,
        executionMethod: 'batch',
        maxBatchOrders: 10,
        tradingViewName: 'BITMART',
        ob_lvls: 50,
    },
    {
        name: "ByBit",
        fullName: "ByBit",
        networkAlias: "bybit",
        iconName: "bybit",
        network: CexNamesEnum.bybit,
        isCex: true,
        coingeckoName: null,
        executionMethod: 'batch',
        maxBatchOrders: 10,
        tradingViewName: 'BYBIT',
        ob_lvls: 200,
    },
    {
        name: "Bitget",
        fullName: "Bitget",
        networkAlias: "bitget",
        iconName: "bitget",
        network: CexNamesEnum.bitget,
        isCex: true,
        coingeckoName: null,
        executionMethod: 'batch',
        maxBatchOrders: 50,
        tradingViewName: 'BITGET',
        ob_lvls: 150,
    },
    {
        name: "BingX",
        fullName: "BingX",
        networkAlias: "bingx",
        iconName: "bingx",
        network: CexNamesEnum.bingx,
        isCex: true,
        coingeckoName: null,
        executionMethod: 'batch',
        maxBatchOrders: 5,
        tradingViewName: 'BINGX',
        ob_lvls: 500,
    },
    {
        name: "Coinbase",
        fullName: "Coinbase",
        networkAlias: "coinbase",
        iconName: "coinbase",
        network: CexNamesEnum.coinbase,
        isCex: true,
        coingeckoName: CoingeckoCexes.coinbase,
        executionMethod: 'single',
        maxBatchOrders: 0,
        tradingViewName: 'COINBASE',
        ob_lvls: 500,
    },
    {
        name: "P2B",
        fullName: "P2B",
        networkAlias: "p2b",
        iconName: "p2b",
        network: CexNamesEnum.p2b,
        isCex: true,
        coingeckoName: CoingeckoCexes.p2b,
        executionMethod: 'single',
        maxBatchOrders: 0,
        ob_lvls: 500,
    },
    {
        name: "Woo",
        fullName: "WOO",
        networkAlias: "woo",
        iconName: "woo",
        network: CexNamesEnum.woo,
        isCex: true,
        coingeckoName: CoingeckoCexes.woo,
        executionMethod: 'single',
        maxBatchOrders: 0,
        tradingViewName: 'WOONETWORK',
        ob_lvls: 500,
    },
    {
        name: "LBank",
        fullName: "LBank",
        networkAlias: "lbank",
        iconName: "lbank",
        network: CexNamesEnum.lbank,
        isCex: true,
        coingeckoName: CoingeckoCexes.lbank,
        executionMethod: 'single',
        maxBatchOrders: 0,
        ob_lvls: 200,
    },
    {
        name: "XT",
        fullName: "XT.COM",
        networkAlias: "xt",
        iconName: "xt",
        network: CexNamesEnum.xt,
        isCex: true,
        coingeckoName: CoingeckoCexes.xt,
        executionMethod: 'single',
        maxBatchOrders: 0,
        ob_lvls: 500,
    },
    {
        name: "Bitrue",
        fullName: "Bitrue",
        networkAlias: "bitrue",
        iconName: "bitrue",
        network: CexNamesEnum.bitrue,
        isCex: true,
        coingeckoName: CoingeckoCexes.bitrue,
        executionMethod: 'single',
        maxBatchOrders: 0,
        tradingViewName: 'BITRUE',
        ob_lvls: 500,
    },
    {
        name: "Ascendex",
        fullName: "Ascendex",
        networkAlias: "ascendex",
        iconName: "ascendex",
        network: CexNamesEnum.ascendex,
        isCex: true,
        coingeckoName: CoingeckoCexes.ascendex,
        executionMethod: 'batch',
        maxBatchOrders: 10,
        ob_lvls: 500,
    },
    {
        name: 'BloFin',
        fullName: 'BloFin',
        networkAlias: 'blofin',
        iconName: 'blofin',
        network: CexNamesEnum.blofin,
        isCex: true,
        coingeckoName: CoingeckoCexes.blofin,
        executionMethod: 'batch',
        maxBatchOrders: 20,
        tradingViewName: 'BLOFIN',
        ob_lvls: 100,
    },
    // {
    //     name: 'WEEX',
    //     fullName: 'WEEX',
    //     networkAlias: 'weex',
    //     iconName: 'weex',
    //     network: CexNamesEnum.weex,
    //     isCex: true,
    //     coingeckoName: CoingeckoCexes.weex,
    //     executionMethod: 'batch',
    //     maxBatchOrders: 10,
    //     tradingViewName: 'WEEX',
    //     ob_lvls: 200,
    // },
    // {
    //     name: 'Biconomy',
    //     fullName: 'Biconomy',
    //     networkAlias: 'biconomy',
    //     iconName: 'biconomy',
    //     network: CexNamesEnum.biconomy,
    //     isCex: true,
    //     coingeckoName: CoingeckoCexes.biconomy,
    //     executionMethod: 'single',
    //     maxBatchOrders: 0,
    //     tradingViewName: undefined,
    //     ob_lvls: 100,
    // },
    // {
    //     name: 'BTSE',
    //     fullName: 'BTSE',
    //     networkAlias: 'btse',
    //     iconName: 'btse',
    //     network: CexNamesEnum.btse,
    //     isCex: true,
    //     coingeckoName: CoingeckoCexes.btse,
    //     executionMethod: 'single',
    //     maxBatchOrders: 0,
    //     tradingViewName: 'BTSE',
    //     ob_lvls: 100,
    // },
    // {
    //     name: 'Coinstore',
    //     fullName: 'Coinstore',
    //     networkAlias: 'coinstore',
    //     iconName: 'coinstore',
    //     network: CexNamesEnum.coinstore,
    //     isCex: true,
    //     coingeckoName: CoingeckoCexes.coinstore,
    //     executionMethod: 'batch',
    //     maxBatchOrders: 10,
    //     tradingViewName: undefined,
    //     ob_lvls: 100,
    // },
]
